import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useState } from 'react';
import { View } from '../app-components';
import CheckoutForm from './CheckoutForm';
import { SuccessMessage } from './SuccessMessage';
import { FailMessage } from './FailMessage';

const stripePromise = loadStripe(
  'pk_test_N1fruakopqHdoSzfqb7RsGck00IkFDKdqS', // ? Test API of movemetal@gmail.com
);

export default () => ({ navigation }) => {
  const [whatToShow, setWhatToShow] = useState('paymentScreen');
  const amount = navigation?.state?.params?.price;

  let returnComp;

  if (whatToShow === 'paymentScreen') {
    returnComp = (
      <PaymentScreenNew
        setWhatToShow={setWhatToShow}
        amount={amount}
        navigation={navigation}
      />
    );
  }
  if (whatToShow === 'success') {
    returnComp = (
      <SuccessMessage navigation={navigation} setWhatToShow={setWhatToShow} />
    );
  }
  if (whatToShow === 'fail') {
    returnComp = (
      <FailMessage navigation={navigation} setWhatToShow={setWhatToShow} />
    );
  }
  return returnComp;
};

const PaymentScreenNew = ({ amount, setWhatToShow, navigation }) => (
  <View>
    <Elements stripe={stripePromise}>
      <CheckoutForm
        amount={amount}
        setWhatToShow={setWhatToShow}
        navigation={navigation}
      />
    </Elements>
  </View>
);
